import { Buttons } from "@/components/atoms/Buttons";
import { useNavigate } from "react-router";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { UserSideMenu } from "@/components/organisms/UserEditMenu";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";

export const SettingEditTypePage = () => {
  const navigate = useNavigate();

  return (
    <MainTemplate
      nav={false}
      subPage={false}
      menuBtn={false}
      pageTitle="내 정보 수정"
      buttonLeft={
        <Buttons
          type="button"
          size="headerTextIcon"
          layout="text"
          color="bright100"
          icon={<IconArrow />}
          label="뒤로"
          onClick={() => navigate("/setting/user")}
        />
      }
    >
      <UserSideMenu />
    </MainTemplate>
  );
};
